
<span class="air-heading">OA Overview</span>
<div class="screen-wrapper">
    <div class="section-wrapper">
        
<np-tabbed>
    <ul class="tabs">
        <li role="tab" aria-selected="true">Installed</li>
        <li role="tab" aria-selected="false">Removed</li>
    </ul>

    <div class="tab-content" role="tabpanel" aria-hidden="false">
        <app-oa-installed [setOAData]="oAApiData"/>
    </div>

    <div class="tab-content" role="tabpanel" aria-hidden="true">
        <app-oa-removed />
    </div>

</np-tabbed>
        </div>

        <div class="section-wrapper">
            
<np-tabbed>
    <ul class="tabs">
        <li role="tab" aria-selected="true">Installed</li>
        <li role="tab" aria-selected="false">Removed</li>
    </ul>

    <div class="tab-content" role="tabpanel" aria-hidden="false">
        <app-oa-installed-save [OaRemovedData]="oaRemovedData"/>
    </div>

    <div class="tab-content" role="tabpanel" aria-hidden="true">
        <app-oa-removed-save [OaRemovedData]="oaRemovedData"/>
    </div>

</np-tabbed>
        </div>
</div>